export const LAYOUT_NAVBAR_WIDTH = "15rem";
export const LAYOUT_NAVBAR_WIDTH_COLLAPSED = "3rem";
export const LAYOUT_NAVBAR_WIDTH_ASIDE = "60vw";
export const LAYOUT_HEADER_HEIGHT = "4rem";
